export const commisionFields = [
  {
    label: "Тариф банка",
    suffix: "₽",
    name: "base_commission", // "bankRate"
    unitOfMeasurement: "rubles",
  },
  {
    label: "Ставка",
    suffix: "%",
    name: "bank_rate", //"rate",
    unitOfMeasurement: "percent",
  },
  {
    label: "Завышение",
    suffix: "₽",
    name: "overstatement",
    unitOfMeasurement: "rubles",
  },
  {
    label: "Итоговая комиссия",
    suffix: "₽",
    name: "final_commission", // "finalCommission",
    unitOfMeasurement: "rubles",
  },
];
